import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { Company } from '../../api/models/company';

@Component({
    selector: 'lib-company-picker',
    templateUrl: './company-picker.component.html',
    styleUrls: ['./company-picker.component.scss'],
    standalone: false
})
export class CompanyPickerComponent implements OnInit {
  @Input()
  preselectedItem: Company;
  @Input()
  items: Observable<Company[]>;
  @Input()
  multiple: boolean;
  @Input()
  showAllEntry: boolean;
  @Output()
  selectedItemChanged: EventEmitter<Company> = new EventEmitter<Company>();

  ngOnInit() {}
}
